<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <UserMasterForm
        ref="userForm"
        v-model="userForm"
        label-width="10em"
        formMode="search"
        :autocomplete-user-id-set="autocompleteUserIdSet"
        :autocomplete-user-name-set="autocompleteUserNameSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import UserMasterForm from '@/components/organisms/dialog/master/UserMasterForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    UserMasterForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteUserIdSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteUserNameSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      userForm: {
        user_id: undefined,
        user_name: undefined,
        customer_code: undefined,
        phone_number: undefined,
        email: undefined,
        role_id: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterDetailSearchDialog.mounted')
  },
  methods: {
    clickClear () {
      this.$refs.userForm.clearFields()
    },
    clickSearch () {
      this.$refs.userForm.validate()
        .then((valid) => {
          sessionStorage.setItem('userSearchCond', JSON.stringify(this.userForm))
          this.dialogVisible = false
          this.$emit('search', this.userForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('userSearchCond'))
      this.$nextTick(() => {
        this.$refs.userForm.clearFields()
        if (searchCond) {
          Object.keys(this.userForm).forEach((x) => {
            this.$set(this.userForm, x, searchCond[x])
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
